module.exports = __webpack_public_path__ + "static/media/trash-red.83f1d7d8.svg";